<template>
  <div>
    <temporary-items-table :exclude-actions="['archive', 'approve']"/>
  </div>
</template>

<script>
  import TemporaryItemsTable from "@/modules/items/temporary/TemporaryItemsTable";
  import {createNamespacedHelpers} from "vuex";

  const {mapActions} = createNamespacedHelpers('temporaryItems');

  export default {
    name: "ArchivedTemporaryItems",
    components: {TemporaryItemsTable},
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'archivedInventoryItems',
        extraFilters: {is_archived: true},
      });
    }
  }

</script>
